import noodleApiClient, { ApiDefinition } from '@noodleApi';

type THIS_API = ApiDefinition['/creators/{creatorId}/workflows/{workflowSlug}/active-user-workflows']['GET'];
type Input = THIS_API['params'] & THIS_API['query'];
type Output = THIS_API['response'];

const getActiveUserWorkflowsForUser = async ({ creatorId, page, perPage, workflowSlug }: Input): Promise<Output> => {
  const response = await noodleApiClient.get(`/creators/${creatorId}/workflows/${workflowSlug}/active-user-workflows`, {
    params: { page, perPage },
  });
  return response.data;
};

export default getActiveUserWorkflowsForUser;
